import React, {Fragment} from 'react';

import {DocHeaderStructure} from 'app/general/structures/DocHeader';
import {MainContentContainer} from 'app/general/structures/MainContentContainer';
import {SPPage} from 'app/general/structures/SPPage';
import {SweetError} from 'app/utils/errors';
import {gt} from 'app/utils/i18n';
import {reportToSentry} from 'app/utils/sentry';

import {ErrorContent} from './ErrorContent';
import {LoadingLine} from './LoadingLine';
import {NotFoundContent} from './NotFoundContent';

export interface SPErrorType {
  response: {
    status: number;
  };
}

interface Props {
  error?: SweetError;
}

export function DetailLoadingPage({error}: Props): JSX.Element {
  React.useEffect(() => {
    if (error != null) {
      reportToSentry(
        error,
        {
          sentBy: 'DetailLoadingPage',
        },
        true
      );
    }
  }, [error]);

  return (
    <SPPage
      pageTitle={gt('Loading...')}
      horizontalPadding={false}
      breadcrumbProps={{
        docName: <LoadingBreadcrumbName />,
      }}
    >
      {error == null ? (
        <Fragment>
          <DocHeaderStructure
            titleContent={<LoadingPageTitle />}
            descriptionContent={<LoadingLine height="1rem" width="60%" />}
          />
          <MainContentContainer>
            <LoadingPageContent />
          </MainContentContainer>
        </Fragment>
      ) : error.response != null && error.response.status === 404 ? (
        <MainContentContainer>
          <NotFoundContent />
        </MainContentContainer>
      ) : (
        <MainContentContainer>
          <ErrorContent />
        </MainContentContainer>
      )}
    </SPPage>
  );
}

export function LoadingBreadcrumbName(): JSX.Element {
  return (
    <LoadingLine
      className="d-inline-block"
      width="150px"
      height="1rem"
      color="#67cad9"
      verticalAlign="text-bottom"
    />
  );
}

export function LoadingPageTitle({
  className,
}: {
  className?: string;
}): JSX.Element {
  return (
    <h1 className={className}>
      <LoadingLine height="2.2rem" marginBottom="1rem" />
    </h1>
  );
}

export function LoadingPageContent(): JSX.Element {
  return (
    <>
      <LoadingLine marginBottom="1rem" height="1rem" />
      <LoadingLine marginBottom="1rem" height="1rem" width="80%" />
      <LoadingLine marginBottom="1rem" height="1rem" />
      <LoadingLine marginBottom="1rem" height="1rem" width="60%" />
    </>
  );
}

export {LoadingLine};
